import * as React from 'react';
import { Props, propTypes } from './props';
import { Icon } from 'semantic-ui-react';

export default class CheckCellRenderer extends React.Component<Props> {
  static propTypes = propTypes;

  render() {
    let content;
    if (this.props.value === true) {
      content = (<Icon name="warning sign" color="yellow" />);
    } else {
      content = null;
    }
    
    return content;
  }
}


// WEBPACK FOOTER //
// ./src/components/user-grid/cell/renderers/warning/component.tsx